declare namespace $ {

	type $mol_button_major__title_shm_projects_task_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_task_2 = $mol_type_enforce<
		ReturnType< $shm_projects_task['send_agent_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_task_3 = $mol_type_enforce<
		ReturnType< $shm_projects_task['send_agent'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_projects_task_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_task_5 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_task_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_projects_task_7 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_result'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_page__title_content_shm_projects_task_8 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_title_rows'] >
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_projects_task_9 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_string_button__value_shm_projects_task_10 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__submit_shm_projects_task_11 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_projects_task_12 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_projects_task['task_title_commit'] > ): ReturnType< $shm_projects_task['task_title_commit'] >,
			keydown( next?: ReturnType< $shm_projects_task['task_title_keydown'] > ): ReturnType< $shm_projects_task['task_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $shm_projects_goal_request__label_shm_projects_task_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_goal_request['label'] >
	>
	type $shm_projects_goal_request__requirements_shm_projects_task_14 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_projects_goal_request['requirements'] >
	>
	type $shm_projects_goal_request__value_shm_projects_task_15 = $mol_type_enforce<
		ReturnType< $shm_projects_task['description_draft'] >
		,
		ReturnType< $shm_projects_goal_request['value'] >
	>
	type $shm_projects_goal_request__after_shm_projects_task_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_projects_goal_request['after'] >
	>
	type $mol_view__sub_shm_projects_task_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_task_chat__run_shm_projects_task_18 = $mol_type_enforce<
		ReturnType< $shm_projects_task['run_data'] >
		,
		ReturnType< $shm_projects_task_chat['run'] >
	>
	type $shm_projects_task_chat__iteration_shm_projects_task_19 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_iteration'] >
		,
		ReturnType< $shm_projects_task_chat['iteration'] >
	>
	type $shm_projects_task_chat__version_shm_projects_task_20 = $mol_type_enforce<
		ReturnType< $shm_projects_task['project_version'] >
		,
		ReturnType< $shm_projects_task_chat['version'] >
	>
	type $shm_projects_task_chat__workspace_id_shm_projects_task_21 = $mol_type_enforce<
		ReturnType< $shm_projects_task['workspace_id'] >
		,
		ReturnType< $shm_projects_task_chat['workspace_id'] >
	>
	type $shm_projects_task_chat__prompt_shm_projects_task_22 = $mol_type_enforce<
		ReturnType< $shm_projects_task['message_draft'] >
		,
		ReturnType< $shm_projects_task_chat['prompt'] >
	>
	type $shm_projects_task_chat__send_shm_projects_task_23 = $mol_type_enforce<
		ReturnType< $shm_projects_task['send_message'] >
		,
		ReturnType< $shm_projects_task_chat['send'] >
	>
	type $shm_projects_task_chat__after_shm_projects_task_24 = $mol_type_enforce<
		ReturnType< $shm_projects_task['agent_after'] >
		,
		ReturnType< $shm_projects_task_chat['after'] >
	>
	type $mol_view__sub_shm_projects_task_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_task extends $mol_book2 {
		task_pages( ): readonly(any)[]
		task_title_rows( ): readonly(any)[]
		task_body( ): readonly(any)[]
		task_title_draft( next?: string ): string
		task_title_commit( next?: any ): any
		task_title_keydown( next?: any ): any
		description_draft( next?: string ): string
		send_agent_enabled( ): boolean
		send_agent( next?: any ): any
		Send_agent( ): $mol_button_major
		Description_title( ): $mol_view
		task_description( ): string
		Description_text( ): $mol_text
		run_data( next?: any ): any
		task_iteration( ): number
		project_version( ): string
		workspace_id( ): string
		message_draft( next?: string ): string
		send_message( next?: any ): any
		agent_after( ): readonly(any)[]
		Result_title( ): $mol_view
		task_result( ): string
		Result_text( ): $shm_hitalama_text
		project_id( ): string
		task_id( ): string
		pages( ): ReturnType< $shm_projects_task['task_pages'] >
		Details_page( ): $mol_page
		Task_title( ): $mol_string_button
		Description_draft( ): $shm_projects_goal_request
		Description_card( ): $mol_view
		Agent( ): $shm_projects_task_chat
		Result_card( ): $mol_view
	}
	
}

//# sourceMappingURL=task.view.tree.d.ts.map